/* eslint-disable */
import { useEffect } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import css from './index.module.scss';

import './index.module.scss';

const ArticleFrame = ({ body }) => {
  useEffect(() => {
    const af = document.querySelector('.' + css.ArticleFrame);
    if (af) {
      af.innerHTML = body ? body.replaceAll('\t', '&nbsp;&nbsp;&nbsp;&nbsp;') : '';
      fixImage(af);
    }
  }, [body]);

  const fixImage = block => {
    if (block.firstElementChild) {
      let elem = block.firstElementChild.childNodes;

      const strongText = block.getElementsByTagName('strong');
      if (strongText.length) {
        for (let i = 0; i < strongText.length; i++) {
          strongText[i].style.fontWeight = 700;
        }
      }

      const videoFrame = block.getElementsByClassName('ql-video');
      if (videoFrame.length) {
        for (let i = 0; i < videoFrame.length; i++) {
          videoFrame[i].style.width = '100%';
          videoFrame[i].style.height = '30vh';
        }
      }

      const quoteText = block.getElementsByTagName('blockquote');
      if (quoteText.length) {
        for (let i = 0; i < quoteText.length; i++) {
          quoteText[i].style.padding = '10px 15px';
          quoteText[i].style.borderLeft = '0.5em solid #eee';
        }
      }

      for (let indent = 1; indent <= 8; indent++) {
        const indentElements = block.getElementsByClassName('ql-indent-' + indent);

        if (indentElements.length) {
          for (let i = 0; i < indentElements.length; i++) {
            indentElements[i].style.paddingLeft = 3 * indent + 'em';
          }
        }
      }

      const textCenterAlign = block.getElementsByClassName('ql-align-center');
      if (textCenterAlign.length) {
        for (let i = 0; i < textCenterAlign.length; i++) {
          textCenterAlign[i].style.textAlign = 'center';
        }
      }

      const textRigthAlign = block.getElementsByClassName('ql-align-right');
      if (textRigthAlign.length) {
        for (let i = 0; i < textRigthAlign.length; i++) {
          textRigthAlign[i].style.textAlign = 'right';
        }
      }

      const textJustifyAlign = block.getElementsByClassName('ql-align-justify');
      if (textJustifyAlign.length) {
        for (let i = 0; i < textJustifyAlign.length; i++) {
          textJustifyAlign[i].style.textAlign = 'justify';
        }
      }

      const textDotList = document.querySelectorAll('ol li[data-list="bullet"]');
      if (textDotList.length) {
        for (let i = 0; i < textDotList.length; i++) {
          textDotList[i].parentElement.style = 'list-style-type: disc;';
        }
      }

      const checkedList = document.querySelectorAll('ol li[data-list="checked"]');
      if (checkedList.length) {
        for (let i = 0; i < checkedList.length; i++) {
          const parent = document.createElement('div');
          parent.innerHTML =
            '<input type="checkbox" checked="true" style="margin-right: 8px">' + checkedList[i].innerHTML;

          checkedList[i].parentElement.style =
            'display: flex; flex-direction: column; align-items: flex-start; padding-left: 15px;';

          checkedList[i].replaceWith(parent);
        }
      }

      const uncheckedList = document.querySelectorAll('ol li[data-list="unchecked"]');
      if (uncheckedList.length) {
        for (let i = 0; i < uncheckedList.length; i++) {
          const parent = document.createElement('div');
          parent.innerHTML = '<input type="checkbox" style="margin-right: 8px">' + uncheckedList[i].innerHTML;

          uncheckedList[i].parentElement.style =
            'display: flex; flex-direction: column; align-items: flex-start; padding-left: 15px;';

          uncheckedList[i].replaceWith(parent);
        }
      }

      for (let i = 0; i < elem.length; i++) {
        if (elem[i].tagName === 'IMG') {
          let value = elem[i].getAttribute('width');
          elem[i].style.width = value;
        }
      }
    }
  };

  return (
    // TODO: X-Frame-Option need fix (Stan).
    //<iframe
    //    className={css.ArticleFrame}
    //    title={title}
    //    id="articleFrame"
    //    src={url}
    //    referrerPolicy="no-referrer"
    //    sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
    //    height="100%"
    //    width="100%"
    ///>
    <div className={classNames('ql-editor', css['ql-editor-height'])}>
      <span className={css.ArticleFrame} data-qa='articleDescription' />
    </div>
  );
};

ArticleFrame.propTypes = {
  body: PropTypes.string.isRequired,
};

export default ArticleFrame;
